import { Link } from "react-router-dom";
import logo from './../assets/LogoGreen.png';
import iconInsta from './../assets/iconInsta.png';
import iconLinke from './../assets/iconLinke.png';

type Props = {}

function Footer({ }: Props) {
    return (
        <div className="bg-secondBlack rounded-xl py-8 px-10">
            <div className="flex flex-col md:flex-row xl:flex-row">
                <div className='flex flex-col flex-1 items-center md:items-start xl:items-start'>
                    <img src={logo} className='w-24'/>
                    <span className='font-regular text-white text-sm md:text-base xl:text-xl mt-4 text-center md:text-left xl:text-left'>Keep up with Onxite news and product features</span>
                    {/*<input name="email" className="mt-4 h-12 rounded-md w-3/4 px-4 " placeholder="Enter email address..."/>*/}
                    <div className="bg-neonGreen py-2.5 px-3.5 rounded-md w-fit mt-4">
                            <Link
                                to="/connect"
                                className="text-black font-bold text-sm md:text-base xl:text-base"
                                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                            >
                                Subscribe
                            </Link>
                    </div>
                </div>
                <div className="flex flex-col items-center md:items-end xl:items-end flex-1 mt-14 md:mt-0 xl:mt-0 gap-3 xl:gap-0">
                    <Link to="/howitworks" className="text-white font-regular text-base md:text-lg xl:text-lg" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>How It Works</Link>
                    {/*<Link to="/pricing" className="text-white font-regular text-base md:text-lg xl:text-lg" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Pricing</Link>*/}
                    <Link to="/connect" className="text-white font-regular text-base md:text-lg xl:text-lg" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Connect</Link>
                </div>
            </div>
            <div className="flex flex-col md:flex-row xl:flex-row mt-20 w-full">
                <div className="flex flex-col md:flex-row xl:flex-row items-center flex-1 gap-2 md:gap-0 xl:gap-0">
                    <Link to="/privacypolicy" className=" text-white font-regular text-sm md:text-base xl:text-base" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Privacy Policy</Link>
                    <span className="font-regular text-grayText text-xs md:text-sm xl:text-sm pl-4">© 2025 Onxite. All rights reserved.</span>
                </div>
                <div className="flex flex-row mt-5 xl:mt-0 justify-center xl:justify-end">
                    <a href="https://www.instagram.com/onxiteanalytics/" target="_blank" rel="noopener noreferrer">
                        <img src={iconInsta} alt="Instagram" className="size-6" />
                    </a>
                    <a href="https://www.linkedin.com/company/onxite" target="_blank" rel="noopener noreferrer" className="ml-2">
                        <img src={iconLinke} alt="LinkedIn" className="size-6" />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Footer